// ============================================================================
// Sonix .sn8 Binary Format Parser (stub)
// ============================================================================
//
// The .sn8 format is Sonix's proprietary firmware binary format.
// Exact format details need to be reverse-engineered from .sn8 files
// generated by Sonix development tools.

export interface ParsedSn8 {
  data: Uint8Array;
  baseAddress: number;
  chipType?: string;
}

/**
 * Parse a Sonix .sn8 firmware file.
 *
 * Stub implementation: currently treats the file as a raw binary blob.
 * A real implementation would parse the .sn8 header to extract:
 * - Target chip type
 * - Flash base address
 * - Code section boundaries
 * - Checksum/CRC fields
 */
export function parseSn8(buffer: ArrayBuffer, baseAddress: number = 0x0000): ParsedSn8 {
  return {
    data: new Uint8Array(buffer),
    baseAddress,
    chipType: undefined,
  };
}
